import React from 'react'
import { FilterChip } from '@entur/chip'

export type FilterChipInfo = {
  value: string
  name: string
  isChecked: boolean
}

type CustomFilterChipProps = {
  filterChipInfo: FilterChipInfo
  setFilterChipInfo: (filterChipInfo: FilterChipInfo) => void
}

export const CustomFilterChip: React.FC<CustomFilterChipProps> = ({ filterChipInfo, setFilterChipInfo }) => {
  return (
    <FilterChip
      data-cy="filter-chip"
      checked={filterChipInfo.isChecked}
      onChange={() => setFilterChipInfo({ ...filterChipInfo, isChecked: !filterChipInfo.isChecked })}
      value={filterChipInfo.value}
    >
      {filterChipInfo.name}
    </FilterChip>
  )
}
